var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7699 0L20.3825 2.6022C19.922 5.69521 17.0928 8.16513 13.43 8.67174L12.5405 8.79476L13.43 8.91779C17.0928 9.4244 19.922 11.8943 20.3825 14.9873L20.7699 17.5895L21.1573 14.9873C21.6178 11.8943 24.447 9.4244 28.1098 8.91779L28.9993 8.79476L28.1098 8.67174C24.447 8.16513 21.6178 5.69522 21.1573 2.60221L20.7699 0Z",
    fill: "#F8AB51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09435 0.671875L4.85454 2.27323C4.56949 4.17662 2.81807 5.69657 0.550621 6.00833L-1.77771e-05 6.08404L0.550622 6.15975C2.81807 6.4715 4.56949 7.99145 4.85454 9.89484L5.09435 11.4962L5.33417 9.89484C5.61922 7.99145 7.37064 6.4715 9.63808 6.15975L10.1887 6.08404L9.63808 6.00833C7.37064 5.69657 5.61922 4.17662 5.33417 2.27323L5.09435 0.671875Z",
    fill: "#F8AB51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01287 14.2031L8.80994 15.5042C8.56875 17.0507 7.08678 18.2857 5.16817 18.539L4.70225 18.6005L5.16817 18.662C7.08678 18.9153 8.56875 20.1503 8.80994 21.6968L9.01287 22.9979L9.21579 21.6968C9.45698 20.1503 10.939 18.9153 12.8576 18.662L13.3235 18.6005L12.8576 18.539C10.939 18.2857 9.45698 17.0507 9.21579 15.5042L9.01287 14.2031Z",
    fill: "#F8AB51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparks);
export default __webpack_public_path__ + "static/media/sparks.e9e9268ca7a85f7dd1b3a7e1cd59eec2.svg";
export { ForwardRef as ReactComponent };